import styled from "styled-components";

export const SiteInfo = styled.div`
  width: calc(100vw - 320px);
  padding: 8px 160px;
  border-bottom: 1px solid;
  border-color: var(--gray-light);
  background-color: var(--gray-lightest);

  position: sticky;
  top: 0;
  z-index: 10000;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  body.high-contrast & {
    background: #000 !important;
    color: #fff !important;
    border-bottom: 2px solid #ffff00 !important;
  }

  > span {
    font-size: 0.75rem;
  }

  @media (max-width: 960px) {
    width: calc(100vw - 80px);
    padding: 8px 40px;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 40px);
    padding: 8px 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Button = styled.button`
  width: 36px;
  height: 36px;

  border-radius: 8px;

  border: 1px solid #dcdcdc;

  background: white;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  &:focus {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
  }

  img {
    width: 18px;
    height: 18px;
  }
`;

export const AdminAreaButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;

  border-radius: 8px;
  border: 1px solid #dcdcdc;

  background: white;
  color: var(--neutral);

  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;

  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  &:focus {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
  }

  body.high-contrast & {
    background: #000 !important;
    color: #fff !important;
    border: 2px solid #ffff00 !important;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100vw - 320px);
  padding: 24px 160px;
  justify-content: space-between;
  gap: 24px;
  border-bottom: 1px solid var(--gray-lightest);
  position: relative;
  background: var(--lightest);
  body.high-contrast & {
  background: #000 !important;
  border-bottom: 2px solid #ffff00 !important;
  }
  

  @media (max-width: 960px) {
    width: calc(100vw - 160px);
    padding: 8px 80px;
  }

  @media (max-width: 698px) {
    width: calc(100vw - 80px);
    padding: 8px 40px;
    flex-direction: column-reverse;
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  position: relative;

  > .search-icon {
    position: absolute;
    right: 16px;
    top: 12px;
  }

  @media (max-width: 698px) {
    width: 100%;
  }
`;

export const SearchInput = styled.input`
  border-width: 1px;
  border-style: solid;
  border-color: var(--gray-light);
  border-radius: 25px;
  padding: 12px;
  color: var(--neutral);
  width: 100%;
  flex: 1;

  body.high-contrast & {
  background: #111 !important;
  color: #fff !important;
  border: 2px solid #ffff00 !important;
}
`;

export const Logo = styled.img`
  width: 200px;

  @media (max-width: 960px) {
    width: 160px;
  }
`;

export const MediaButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: 1;
  justify-content: flex-end;

  @media (max-width: 720px) {
    display: none;
  }
  
  &.social-button {
  background: var(--primary);
}
`;

export const MediaButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary);
  border-radius: 28px;
  width: 56px;
  height: 56px;
  border: none;
  cursor: pointer;

  @media (max-width: 960px) {
    width: 48px;
    height: 48px;
  }

  &:hover {
    background: var(--primary-light);
  }
`;

export const SideMenuButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  background: var(--primary);
  border-radius: 28px;
  width: 48px;
  height: 48px;
  border: none;
  position: relative;
  right: 16px;
  top: 12px;

  @media (max-width: 720px) {
    display: flex;
  }
`;

